import { render, staticRenderFns } from "./CartPanels.vue?vue&type=template&id=196dae44&scoped=true&"
import script from "./CartPanels.vue?vue&type=script&lang=js&"
export * from "./CartPanels.vue?vue&type=script&lang=js&"
import style0 from "./CartPanels.vue?vue&type=style&index=0&id=196dae44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196dae44",
  null
  
)

export default component.exports